import React, { useCallback } from 'react'

import { List as ImmutableList } from 'immutable'

import { queueTrackingEvent } from '@library/tracking-integration'

import DropdownInput from 'components/Form/Dropdown'
import { AddRecipeFn, useBasket } from 'routes/Menu/domains/basket'
import { UserOrder } from 'utils/types/order'

import { Calendar } from '../Calendar'
import { SlotPicker } from '../SlotPicker'
import { Slots } from '../types'

import css from '../DeliverySlot.css'

type DeliveryDay = {
  date: string
  value: string
  disabled: boolean
  orderId?: string | null
  icon: string | null
}

type DatePickerProps = {
  slots: Slots
  slotId: string
  deliveryDays: DeliveryDay[]
  disableNewDatePicker: boolean
  tempDate: string
  tempSlotId: string
  tempOrderId: string | undefined
  setTempSlotId: (slotId: string) => void
  handleDateChange: (date: string, orderId: string, addRecipe: AddRecipeFn) => void
  subLabelClassName: string
  hideSlotPicker: boolean
  userOrders?: ImmutableList<UserOrder>
}

export const DatePicker = (props: DatePickerProps) => {
  const {
    slots,
    slotId,
    deliveryDays,
    disableNewDatePicker,
    tempDate,
    tempSlotId,
    tempOrderId,
    setTempSlotId,
    handleDateChange,
    subLabelClassName,
    hideSlotPicker = false,
    userOrders,
  } = props
  const deliverySlotOptions = slots[tempDate] || []

  const { addRecipe } = useBasket()
  const enrichedHandleDateChange = useCallback(
    (date, orderId) => {
      handleDateChange(date, orderId, addRecipe)
      queueTrackingEvent<{
        action: 'choose_delivery_date'
      }>({
        action: 'choose_delivery_date',
        properties: {
          delivery_date: date,
        },
      })
    },
    [handleDateChange, addRecipe],
  )

  return disableNewDatePicker ? (
    <div className={css.bsRow}>
      <div className={css.halfLeft}>
        <DropdownInput
          color="secondary"
          uppercase
          options={deliveryDays}
          onChange={enrichedHandleDateChange}
          value={tempDate}
          className={css.dropdown}
          subLabelClassName={subLabelClassName}
        />
      </div>
      <div className={css.halfRight}>
        <DropdownInput
          color="secondary"
          uppercase
          options={deliverySlotOptions}
          onChange={setTempSlotId}
          value={tempSlotId}
          className={css.dropdown}
        />
      </div>
    </div>
  ) : (
    <span>
      <div className={css.row}>
        <Calendar
          dates={deliveryDays}
          selected={tempDate}
          onClick={enrichedHandleDateChange}
          userOrders={userOrders}
        />
      </div>
      {!hideSlotPicker && (
        <div className={tempOrderId ? css.disabledRow : css.row}>
          <SlotPicker slots={slots} date={tempDate} slotId={slotId} onClick={setTempSlotId} />
        </div>
      )}
    </span>
  )
}
